import AppointmentPosition from './AppointmentPosition'
export default AppointmentPosition